import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'

function ErrorFallback() {
  return (
    <h4 style={{ textAlign: 'center', opacity: 0.5 }}>
      An error occured. Please refresh.
    </h4>
  )
}

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}
